import { observer } from 'mobx-react'
import { FC, useContext, useEffect } from 'react'
import { AddUserModal } from './ModalTypes/AddUserModal'
import { AddGroupModal } from './ModalTypes/AddGroupModal'
import { AddPermissionModal } from './ModalTypes/AddPermissionModal'
import { StoreContext } from '../App'
import { AddConfigurationModal } from './ModalTypes/AddConfigurationModal'
import { ConfirmationModal } from './ModalTypes/ConfirmationModal'
import { ChangelogModal } from './ModalTypes/ChangelogModal'

interface ModalTypeProps {
  type: string
}

const ModalType: FC<ModalTypeProps> = observer(({ type }) => {
  switch (type) {
    case 'add-user':
      return <AddUserModal />
    case 'add-group':
      return <AddGroupModal />
    case 'add-permission':
      return <AddPermissionModal />
    case 'add-configuration':
      return <AddConfigurationModal />
    case 'confirmation':
      return <ConfirmationModal />
    case 'changelog':
      return <ChangelogModal />
    default:
      return <></>
  }
})

export const ModalHandler: FC = observer(() => {
  const store = useContext(StoreContext)
  const { openedModals } = store.ModalState

  useEffect(() => {
    console.log(openedModals)
  }, [openedModals])

  return openedModals.map((modal, v) => <ModalType key={modal + v} type={modal} />)
})
